export const getFlattenObject = (obj, prefix = "", separator = ".") => {
  const result = {};

  for (const [key, value] of Object.entries(obj)) {
    const newKey = prefix ? `${prefix}${separator}${key}` : key;

    if (value && typeof value === "object" && !Array.isArray(value)) {
      // Recursively flatten nested objects
      Object.assign(result, getFlattenObject(value, newKey, separator));
    } else {
      // Assign primitive values or arrays directly
      result[newKey] = value;
    }
  }

  return result;
};
